import axios from "axios";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import productSchema from '../../ValidationSchema/Product.schema.js'

const CreateProduct = () => {
  const inputDiv = "mb-4 flex flex-col";
  const inputLabel = "mb-2 text-xl";
  const inputCss = "p-2 border-2 rounded-md";

  const { user } = useSelector(state => state.user);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    sellingPrice: "",
    buyingPrice: "",
    stock: "",
    gst: "",
    discount: "",
    category: "",
    MRP: "",
    materialCode: ""
  });

  const Star = () => <span className="text-red-600 font-bold">*</span>

  const [categories, setCategories] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/category/");
        if (response.data.success) {
          setCategories(response.data.categories);
          toast.success(response.data.message);
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }

    })();
  }, []);

  //whenever user types in input fields, handles ==>
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.category) return toast.error("Required Category!");
    console.log({ formData });

    let data;
    try {
      data = productSchema.parse(formData);
    } catch (error) {
      toast.error(error.errors[0].message);
      return;
    }

    try {
      const response = await axios.post("/product/new", data);
      console.log(response);

      if (response.data.success) {
        toast.success(response.data.message);
        navigate("/product")
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <div className="container mx-auto flex justify-center items-center">
        <div
          className=" pt-5 pb-5 mt-5 mb-5 border-secondary  w-2/4 h-3/4 flex flex-col justify-center items-center"
          id="login-box">
          <h1 className="text-center p-2 m-6 text-2xl font-semibold text-blue-700">
            Add Product
          </h1>

          <form onSubmit={handleSubmit} className="w-[60vw] sm:w-[90%] 2xl:w-[65%] flex flex-col space-y-5 border-2 border-blue-600 p-9 rounded-3xl">
            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="form1Example1">
                Product Name <Star />
              </label>
              <input
                type="text"
                id="form1Example1"
                className={inputCss}
                placeholder="Product Name"
                name="name"
                onChange={handleChange}
                value={formData.name}
                required
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="mcode">
                Material Code
              </label>
              <input
                type="text"
                id="mcode"
                className={inputCss}
                placeholder="Material Code"
                name="materialCode"
                onChange={handleChange}
                value={formData.materialCode}
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="form1Example2">
                Selling Price
              </label>
              <input
                type="text"
                id="form1Example2"
                className={inputCss}
                placeholder="Selling Price"
                name="sellingPrice"
                onChange={handleChange}
                value={formData.sellingPrice}
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="buyingPrice">
                Buying Price
              </label>
              <input
                type="text"
                id="buyingPrice"
                className={inputCss}
                placeholder="Buying Price"
                name="buyingPrice"
                onChange={handleChange}
                value={formData.buyingPrice}
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="stock">
                Stock <Star />
              </label>
              <input
                type="text"
                id="stock"
                className={inputCss}
                placeholder="Stock"
                name="stock"
                onChange={handleChange}
                value={formData.stock}
                required
              />
            </div>

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="gst">
                GST
              </label>
              <input
                type="text"
                id="gst"
                className={inputCss}
                placeholder="GST in percent"
                name="gst"
                onChange={handleChange}
                value={formData.gst}
              />
            </div>
            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="discount">
                Discount
              </label>
              <input
                type="text"
                id="discount"
                className={inputCss}
                placeholder="Discount in percent"
                name="discount"
                onChange={handleChange}
                value={formData.discount}
              />
            </div>


            {categories.length > 0 ? <div>
              <label className={inputLabel} htmlFor="category">
                Category <Star />
              </label>
              <select id="category" name="category" onChange={handleChange} value={formData.category}
                className="select select-bordered w-full">
                <option selected>Select Category</option>
                {
                  categories.map((c) => {
                    return (
                      <>
                        <option value={c._id}>{c.title}</option>
                      </>
                    )
                  })
                }
              </select>
            </div> :
              <Link to={"/category/add"} className="text-blue-700 font-bold hover:text-blue-900 p-2 bg-red-200 text-xl text-center rounded-lg underline">Add some categories first!</Link>
            }

            <div className={inputDiv}>
              <label className={inputLabel} htmlFor="MRP">
                MRP
              </label>
              <input
                type="text"
                id="MRP"
                className={inputCss}
                placeholder="MRP Price"
                name="MRP"
                onChange={handleChange}
                value={formData.MRP}
              />
            </div>


            <div className="text-center">
              <button
                type="submit"
                className="bg-blue-700 text-white w-full py-2 rounded-md bottom-2 "
              >
                Add Product
              </button>
            </div>

          </form>

        </div>
      </div>
    </>
  );
};

export default CreateProduct;
